import { addDays, addMonths, isAfter, setDate } from 'date-fns';

export type Frequency = 'monthly' | 'semi-monthly' | 'bi-weekly' | 'weekly';

export interface Schedule {
  frequency: Frequency;
  date1?: number;
  date2?: number;
  nextDate?: any; // Firestore Timestamp or Date
}

export function getNextScheduleDate(schedule: Schedule, baseDate: Date): Date {
  const base = new Date(baseDate);
  base.setHours(0,0,0,0);

  if (schedule.frequency === 'bi-weekly' || schedule.frequency === 'weekly') {
    let next = schedule.nextDate ? (schedule.nextDate.toDate ? schedule.nextDate.toDate() : new Date(schedule.nextDate)) : new Date();
    next.setHours(0,0,0,0);
    
    while (!isAfter(next, base)) {
      next = schedule.frequency === 'bi-weekly' ? addDays(next, 14) : addDays(next, 7);
    }
    return next;
  }

  if (schedule.frequency === 'monthly' && schedule.date1) {
    let next = setDate(base, schedule.date1);
    if (!isAfter(next, base)) {
      next = setDate(addMonths(base, 1), schedule.date1);
    }
    return next;
  }

  if (schedule.frequency === 'semi-monthly' && schedule.date1 && schedule.date2) {
    let next1 = setDate(base, schedule.date1);
    let next2 = setDate(base, schedule.date2);
    
    const candidates = [];
    if (isAfter(next1, base)) candidates.push(next1);
    if (isAfter(next2, base)) candidates.push(next2);
    
    let nextMonth1 = setDate(addMonths(base, 1), schedule.date1);
    let nextMonth2 = setDate(addMonths(base, 1), schedule.date2);
    candidates.push(nextMonth1, nextMonth2);

    candidates.sort((a, b) => a.getTime() - b.getTime());
    return candidates[0];
  }

  return addMonths(base, 1);
}

export function getUpcomingDates(schedule: Schedule, count: number): Date[] {
  const dates: Date[] = [];
  let currentBase = new Date(); // Start from today
  // Wait, if it's due today, we want to show today!
  // So currentBase should be yesterday to include today if it's strictly >
  currentBase.setDate(currentBase.getDate() - 1);

  for (let i = 0; i < count; i++) {
    const nextDate = getNextScheduleDate(schedule, currentBase);
    dates.push(nextDate);
    currentBase = nextDate;
  }
  return dates;
}
